import React, { Component } from 'react';
import ReactDOM from 'react-dom';

type Props = {
    items: string[];
    sort?: boolean;
    autoSelect?: boolean;
    initialValue?: string;
    label?: string;
    width?: string | number;
    autocomplete?: boolean;
    direction?: string;
    onItemSelected: (selectedItem: string) => void
};

type State = {
    open: boolean;
    items: string[];

    searchQuery: string | null;
    selectedItem: string;
}

export class FstyrDropdown extends Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            open: false,
            items: [],

            searchQuery: null,
            selectedItem: "",
        };
    }

    //#region React lifecycle methods
    componentDidMount() {
        this.setInternalStateAndSort();
        document.addEventListener('click', this.handleClickOutside, true);
    }

    componentDidUpdate(prevProps: Readonly<Props>): void {
        if (JSON.stringify(prevProps.items) !== JSON.stringify(this.props.items)) {
            this.setInternalStateAndSort();
        }
        if (prevProps.initialValue !== this.props.initialValue) {
            if (this.props.initialValue) this.selectItem(this.props.initialValue);
            else this.setState({ searchQuery: "" })
        }
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
    }

    handleClickOutside = (event: any) => {
        const domNode = ReactDOM.findDOMNode(this);
        if (domNode && !domNode.contains(event.target)) {
            this.setState({
                open: false
            });
        }
    }

    //#endregion React lifecycle methods
    //#region state changing methods

    setInternalStateAndSort() {
        this.setState({
            items: this.props.sort ? this.props.items.sort() : this.props.items,
        }, () => {
            if (this.state.items.length === 1 || this.props.autoSelect) {
                this.selectItem(this.state.items[0])
            }
            else if (this.props.initialValue) {
                this.selectItem(this.props.initialValue)
            }
        })
    }

    setSearchQuery(value: string) {
        this.setState({
            searchQuery: value,
            open: true
        })
    }

    selectItem(item: string) {
        this.setState({
            open: false,
            selectedItem: item,
            searchQuery: null
        },
            () => this.props.onItemSelected(item)
        )
    }

    toggleDropdown = () => this.setState({ open: !this.state.open })

    //#endregion state changing methods

    getItems = () => {
        return this.state.items.filter(x => this.state.searchQuery ? x.toLowerCase().startsWith(this.state.searchQuery.toLowerCase()) : true).map((x, key) =>
            <button key={key} onClick={() => this.selectItem(x)} id="item">{x}</button>
        )
    }

    render() {
        return (
            <div className={this.props.label && this.props.direction === "row" ? "fstyr-align-row" : ""}>
                {this.props.label && <label className="form-label fstyr-dropdown-label" htmlFor="options">{this.props.label}</label>}
                <span className="form-hint" id="form-text-hint">
                    {""}
                </span>
                <div className="fstyr-dropdown-container">
                    <div style={{ width: this.props.width }} className="fstyr-dropdown" onClick={() => { this.toggleDropdown() }} >
                        <input
                            autoComplete={this.props.autocomplete ? "true" : "false"}
                            readOnly={!this.props.autocomplete}
                            type="text"
                            onChange={(e) => this.setSearchQuery(e.target.value)}
                            value={this.state.searchQuery ?? this.state.selectedItem}
                            id="input"
                        />
                        <div id="icon">
                            <i className={`icon icon-arrow-drop-${this.state.open ? "up" : "down"}`}></i>
                        </div>
                    </div>
                    {this.state.open &&
                        <div style={{ width: this.props.width }} className="fstyr-dropdown-items-container">
                            {this.getItems()}
                        </div>
                    }
                </div>
            </div>
        );
    }
}
